<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { FormEditorSaveEventPayload, FormEditorViewModel } from "@Alternatives/Forms/Components/FormEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class FormEditor extends Vue
    {
        get vm(): FormEditorViewModel { return this.$props.viewModel as FormEditorViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get title(): string { return this.vm.title; }
        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }
        get nameError(): string | null { return this.vm.nameError; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        handleFormSubmit()
        {
            this.vm.clearValidationErrors();
            this.$emit("save-form", new FormEditorSaveEventPayload(this.vm.id, this.name, this.vm.sourceId));
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="form-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input v-model.trim="name" type="text" class="form-control" required maxlength="100" minlength="2">
                                <div class="error">{{nameError}}</div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="form-editor-form" class="btn btn-primary">{{confirmButtonLabel}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>